interface SpeechRecognitionInstance {
  continuous: boolean
  interimResults: boolean
  finalTranscript: string
  lang: string
}

type SpeechRecognitionConstructor = new () => SpeechRecognitionInstance

declare global {
  interface Window {
    SpeechRecognition: SpeechRecognitionConstructor
    webkitSpeechRecognition: SpeechRecognitionConstructor
    SpeechGrammarList: unknown
    webkitSpeechGrammarList: unknown
  }
}

let mic: SpeechRecognitionInstance | boolean = false
if (typeof window !== "undefined") {
  if (window) {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
    if (SpeechRecognition) {
      mic = new SpeechRecognition()
      mic.continuous = false
      mic.interimResults = true
      mic.finalTranscript = ""
      mic.lang = "fr-FR"
    }
  }
}

export const useSpeechToText = () => {
  return mic
}
